import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../lib/loopback'

const mercadoriasRepository = createRepository({
  path: 'mercadorias',
  restApi,
  queryTransform: {
    descricao: query.ilikeWithoutSplit('descricao'),
    ...paginate
  }
})

mercadoriasRepository.sync = () => {
  return restApi.get(`mercadorias/sync`)
}

mercadoriasRepository.simpleList = filter => {
  return restApi.get(`mercadorias/simpleSchema`, filter)
}

export default mercadoriasRepository
